import { render, staticRenderFns } from "./mod-11.vue?vue&type=template&id=e4777344&scoped=true&"
import script from "./mod-11.vue?vue&type=script&lang=js&"
export * from "./mod-11.vue?vue&type=script&lang=js&"
import style0 from "./mod-11.vue?vue&type=style&index=0&id=e4777344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4777344",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
